/**
 * Single source of truth for the homepage hero image AND the social/OG
 * preview image. Whenever the hero changes, update this constant. The same
 * URL is mirrored as a static <meta property="og:image"> in
 * `public/index.html` so non-JS crawlers (Facebook, LinkedIn, WhatsApp,
 * iMessage, LINE) see the right preview without running React.
 *
 * 👉 If you change HERO_IMG, also update the og:image and twitter:image
 *    URLs near the top of `/app/frontend/public/index.html`.
 */
export const HERO_IMG =
    "https://customer-assets.emergentagent.com/job_asc-interior-experts/artifacts/m835keil_Cover.jpg";

export const SITE_NAME = "ASC Interior";
export const SITE_URL = "https://ascinterior.com";
